import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight'
import { Box, Chip, Tab, Tabs, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import Tile from '../layout/Tile'

export interface ITabItem {
    id: string
    name: string
    rightRender?: JSX.Element
    renderPanel: () => JSX.Element
}

interface P {
    primary?: string
    secondary?: string
    chipText?: string
    defaultSelectedTab?: string
    tabs: ITabItem[]
    onTabChange?: (tabId: string) => void
}

function TabsHeader({ primary, secondary, defaultSelectedTab, tabs, chipText, onTabChange }: P) {
    const theme = useTheme()
    const [selectedTab, setSelectedTab] = useState(defaultSelectedTab ?? (tabs[0]?.id ?? ''))
    const tabItem = tabs.find(x => x.id === selectedTab)
    const panel = tabItem?.renderPanel()

    return (
        <Tile.Column flex={0}>
            <Tile.Row flex={0} spacing={1}>
                <Tile.Row alignItems='center' justifyContent='space-between' style={{ alignItems: 'flex-end' }}>
                    <Box flexDirection='column' sx={{ marginBottom: 1 }}>
                        {primary && (
                            <Box display='flex' flexDirection='row'>
                                <Typography fontWeight='bold' variant='h5'>{primary}</Typography>
                                {chipText &&
                                    <Chip sx={{ marginLeft: 2 }} label={chipText} />}
                            </Box>
                        )}
                        {secondary && (
                            <Box display='flex' flexDirection='row' alignItems='center' marginLeft={1}>
                                <SubdirectoryArrowRightIcon fontSize='small' sx={{ marginTop: -1 }} />
                                <Typography variant='subtitle1' fontWeight={500} sx={{ textDecoration: 'underline', textDecorationThickness: '1px', marginLeft: 0.5 }}>{secondary}</Typography>
                            </Box>
                        )}
                    </Box>
                </Tile.Row>
            </Tile.Row>
            <Tile.Row flex={0} spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, borderBottom: 1, borderColor: 'divider', justifyContent: 'space-between' }}>
                    <Tabs
                        value={selectedTab}
                        variant='scrollable'
                        scrollButtons='auto'
                        onChange={(_, newTab) => {
                            setSelectedTab(newTab)
                            if (onTabChange) {
                                onTabChange(newTab)
                            }
                        }}
                        sx={{ justifyContent: 'flex-start' }}>
                        {tabs.map(x => (
                            <Tab key={x.id} label={x.name} value={x.id} sx={{ fontFamily: 'unset' }} />
                        ))}
                    </Tabs>
                    {tabItem?.rightRender}
                </Box>
            </Tile.Row>
            <Tile.Column style={{ paddingTop: theme.spacing(2) }}>
                {panel}
            </Tile.Column>
        </Tile.Column>
    )
}

export default TabsHeader
